import { SELECTAPPLICATION } from "redux/constants/Application";

export default (state = "", action) => {
  switch (action.type) {
    case SELECTAPPLICATION:
      return action.payload;
    default:
      return state;
  }
};
